import React from 'react'
import Markdown from 'react-native-markdown-display'

export default function MarkDownComponet({ content }) {
	return (
		<Markdown
			style={{
				heading1: {
					fontSize: 24,
					fontWeight: 'bold',
					marginBottom: 16,
					paddingRight: 8,
				},
				heading2: {
					fontSize: 20,
					fontWeight: 'bold',
					marginTop: 24,
					marginBottom: 12,
					paddingRight: 8,
				},
				paragraph: {
					fontSize: 16,
					lineHeight: 24,
					marginBottom: 16,
					paddingRight: 8,
				},
				list: {
					marginBottom: 16,
					paddingRight: 8,
				},
				listItem: {
					fontSize: 16,
					lineHeight: 24,
					marginBottom: 8,
					paddingRight: 8,
				},
			}}
		>
			{content}
		</Markdown>
	)
}
